var __vue_script__, __vue_template__
var __vue_styles__ = {}
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter.js!sass-loader!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./loading.vue")
__vue_script__ = require("!!babel-loader!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./loading.vue")
__vue_template__ = require("!!vue-html-loader!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./loading.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
if (__vue_template__) {
__vue_options__.template = __vue_template__
}
if (!__vue_options__.computed) __vue_options__.computed = {}
Object.keys(__vue_styles__).forEach(function (key) {
var module = __vue_styles__[key]
__vue_options__.computed[key] = function () { return module }
})



//////////////////
// WEBPACK FOOTER
// ./web/components/loading/loading.vue
// module id = 88
// module chunks = 0 7 24 25 26 30 39 48 49 52 77 82 93 94 95 100 101 103 104 105 106 109 111 113 114 171 172 174